import { BadgeCellRenderer, type TypeBadgeCellRendererProps } from '@thefarmersfront/kitchen';

/**
 * kitchen BadgeCellRenderer 는 colorMap 에 없는 값을 문자열 그대로 반환해, TS 4.9 에서는 JSX 컴포넌트로 쓸 수 없다.
 * 함수로 호출한 결과를 Fragment 로 감싸 JSX 로 쓰게 한다.
 */
const BadgeCell = <TKey extends string>(props: TypeBadgeCellRendererProps<TKey>) => <>{BadgeCellRenderer(props)}</>;

export default BadgeCell;
